import { IoClose } from 'react-icons/io5';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner } from '@ds';
import { RoutePlannerModalLayoutProps } from '@lp/features/RoutePlanner/components/RouteModals/components/RoutePlannerModal';
import { LegFormValues } from './validation';
import { LegFormWrapper, LegFormWrapperProps, RouteLegFormMode, RouteLegFormProps } from './context/LegFormContext';
import { LegForm } from './components/LegForm';
import { LegFormFooter } from './components/LegFormFooter';

export const RouteLegForm = ({
  baseClassName,
  title,
  isOpen,
  isLoading,
  size,
  onSubmit,
  ...props
}: RouteLegFormProps & RoutePlannerModalLayoutProps & Pick<LegFormWrapperProps, 'onSubmit'>) => {
  const handleSubmit = async (data: LegFormValues) => {
    await onSubmit(data);
  };

  const handleDelete = async (data: LegFormValues) => {
    if (props.mode === RouteLegFormMode.Edit) {
      await props.onDelete(data);
    }
  };

  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={props.onClose}
      scrollBehavior="inside"
      closeButton={<IoClose size={42} className="z-1000" />}
      classNames={{
        base: 'bg-base-80 rounded-md relative',
        body: 'p-4',
        wrapper: 'z-420',
        backdrop: 'z-419',
        closeButton: 'text-base-10 m-4',
        header: 'text-hl! text-base-20 font-secondary flex flex-col gap-1 bg-base-80 rounded-md',
        footer: 'flex flex-col gap-4',
      }}
    >
      <ModalContent>
        <LegFormWrapper onSubmit={handleSubmit} shouldUnregister={false} {...props}>
          {isLoading && (
            <div className="absolute top-0 left-0 flex justify-center items-center z-50 w-full h-full bg-white bg-opacity-40">
              <Spinner size="md" />
            </div>
          )}
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
            <LegForm />
          </ModalBody>
          <ModalFooter>
            <LegFormFooter onDelete={handleDelete} onClose={props.onClose} />
          </ModalFooter>
        </LegFormWrapper>
      </ModalContent>
    </Modal>
  );
};
